import { createGetChannel } from './requestRX';
import {Fetch, ResponseData, ResponseList} from './typeRX';
import {BlockItem, StatisticsInfo} from "@src/models/explorer";
import {PageParams} from "@src/models";

export const GetBlockList: Fetch<PageParams, ResponseList<BlockItem>> = createGetChannel('/api/reexuan-blockchain-service/explorer/getBlockList');
export const GetStatistics: Fetch<{}, ResponseData<StatisticsInfo>> = createGetChannel('/api/reexuan-blockchain-service/explorer/statistics');